import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 260px;
  max-width: 268px;
  padding: 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.colors.black1};
  }
`;

export const IconWrapper = styled.div`
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -0.5px;
`;

export const TitleWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const DescriptionWrapper = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
